export default __webpack_public_path__ + "static/media/covid.bb9cf957.png";